<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <ProjectComponent/>

    </transition>
  </div>
</template>

<script>

import ProjectComponent from '@/components/projects/ProjectComponent/ProjectComponent.vue'

export default {
  name: 'Project',
  components: {
    ProjectComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
